export const InboxFilter_InputRequired = 'input-required';
export const InboxFilter_Pending = 'pending';
export const InboxFilter_Resulted = 'resulted';
export const InboxFilter_Completed = 'completed';
export const InboxFilter_Accepted = 'accepted';
export const InboxFilters = [InboxFilter_InputRequired, InboxFilter_Pending, InboxFilter_Resulted, InboxFilter_Completed, InboxFilter_Accepted];
//# sourceMappingURL=types.js.map